<template>
  <div :class="$vuetify.breakpoint.name === 'lg' ? 'px-2' : 'px-5'">
    <v-row
      class="mt-3"
      :class="$vuetify.breakpoint.name !== 'xs' ? 'px-3' : 'pr-0 pl-3'"
    >
      <v-col cols="12">
        <v-card class="border-radius box-shadow pa-5">
          <v-tabs v-model="activeTab" color="#0299B7">
            <v-tab>Daftar Penerima (Rp)</v-tab>
            <v-tab>Periode Pembayaran</v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <v-tab-item>
              <DaftarPenerima />
            </v-tab-item>
            <v-tab-item>
              <PeriodePembayaran />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DaftarPenerima from "./DaftarPenerima.vue";
import PeriodePembayaran from "./PeriodePembayaran.vue";

export default {
  components: {
    DaftarPenerima,
    PeriodePembayaran
  },
  data() {
    return {
      activeTab: 0
    };
  }
};
</script>
